export default __webpack_public_path__ + "static/media/nanogiants.f1a0cb93.png";